/*
 * Public API Surface of icons
 */
export {IconType} from './lib/icons-storage';
export {IconsModule} from './lib/icons.module';
